<template>
  <div>
    <b-modal id="modalConcluido"  ref="modalConcluido" title="BootstrapVue">
        <p style="color:#707070;font-weight:bold;font-size:22px;margin-top:40px;">{{nomeCad}} cadastrada com sucesso!</p><br>
        <button @click="IrParaPag()">OK</button>
    </b-modal>
      <b-modal
      id="modal-lg"
      ref="modal-lg"
      size="lg"
      hide-footer
      title="Cadastre o certificado da nova empresa">
      <br>
      <label style="font-size:18px;color:#707070;">Razão Social:</label> <span style="color:#707070;font-weight: bold;font-size:18px;">{{$store.state.razaoSocial}}</span>  {{ nome
      }}<br />
      <br />
      <label style="color: #707070;font-weight: bold;">Certificado:</label>
      <b-form-file
        id="xml"
        v-model="file"
        placeholder="Selecione o certificado"
        drop-placeholder="Coloque aqui..."
        accept=".pfx"
      />
      <br />
      <br />
      <br>
      <div class="form-group">
        <label class="labels" style="color: #707070;font-weight: bold;">Senha</label>
        <input
          class="form-control"
          type="password"
          id="senhaCertificado"
          placeholder="Digite a senha do certificado"
          v-model="senha"
        />
      </div>
      <p v-if="msgCertificado" style="color:red;text-align:center;margin-top:30px;position:relative;">{{msgCertificado}}</p>
      <div style="display: flex;justify-content: center;">
        <div class="acoes" style="margin-top:60px;margin-bottom:20px;">
             <br /><br /><span @click="limparcer">Limpar</span>
          <button type="submit" @click="adiconarCertificado()" :disabled="disabledCadCert">
            + Adicionar novo certificado
          </button>
        </div>
      </div>
      <vue-topprogress ref="topProgress"></vue-topprogress>
    </b-modal>
  </div>
</template>

<script>
import config from "../services/config.js";
import { vueTopprogress } from "vue-top-progress";
import barramento from '@/services/barramento'
export default {  
    components: { vueTopprogress },
    data(){
        return{
            nomeCad:"",
            nome:"",
            senha:"",
            file:null,
            msgCertificado:"",
            disabledCadCert:false
        }
    },
    methods:{
        IrParaPag(){
            if(this.$route.name != 'empresas'){
                this.$router.push({
                name:'empresas'
                })
            }else{
                this.$parent.buscarEmpresa()
                this.$refs['modalConcluido'].hide()
            }
        
        },
        verificarStatus(status,campo){
            if(status.status>=400){       
            this[campo] = status.data.message;
            }else{
                this.limparcer();     
                this.$refs['modal-lg'].hide()
                this.$refs['modalConcluido'].show()        
            }
        },
        funMostraModal(){
            this.$refs['modal-lg'].show()
        },
        limparcer(){
            this.senha= ""
            this.file =null
        },
        async adiconarCertificado(){
            if (this.file == null) {
                this.msgCertificado = "Sem certificado";                
            } else if (this.senha == "") {
                this.msgCertificado = "Campo senha não preenchido";                
            } else{
                this.$refs.topProgress.start();
                let formdata = new FormData();
                console.log(this.$store.state.idEmpresa)
                formdata.append("cert_codigo", this.senha.trim());
                formdata.append("file", this.file);
                    let status = await config.cadastrarCertificado(
                    this.$store.state.idEmpresa,                  
                    formdata
                );
                this.verificarStatus(status,"msgCertificado")
                this.$refs.topProgress.done();
            }
        },
        
    }, 
    mounted(){
        barramento.$on('acionarModalDeListaEmpresa', ()=>{this.funMostraModal()})
    },
    created(){
       
        this.nomeCad = this.$route.name == 'cadastrarempresa' ?'Empresa' : 'Certificado'
    }   
}
</script>

<style>
#modal-lg___BV_modal_title_{
    color:#707070;
    font-size: 18px;
    font-weight: bold;
}
header#modalConcluido___BV_modal_header_ {
    display: none;
}
footer#modalConcluido___BV_modal_footer_{
    display: none;
}
#modalConcluido{
    text-align: center;
}
#modalConcluido button{
    text-align: center;
    outline: none;
    width: 70px;
    height: 30px;
    border:none;
    font-size: 14px;
    color:#fff;
    background: #009188;
    border-radius: 5px;
    margin-top:20px;
    margin-bottom: 20px;
}
#modalConcluido button:focus{
    outline: none;
}
</style>